<section id="contact-us-page" class="w-full min-h-screen bg-ld-neutral-50">
  <div
    class="max-w-page mx-auto py-6 page-content-padding grid grid-cols-1 items-start lg:grid-cols-[1fr_360px] lg:gap-6 lg:*:col-start-1"
  >
    <header id="contact-us-header" class="mb-8">
      <h1 id="contact-us-title" class="text-page-title mb-2">
        {{ 'contactUsTitle' | transloco }}
      </h1>
      <p id="contact-us-subtitle" class="text-base text-ld-neutral-500">
        {{ 'contactUsSubtitle' | transloco }}
      </p>
    </header>

    <div id="contact-us-faqs-link" class="mb-8">
      <a
        [routerLink]="faqsLink()"
        class="inline-flex items-center gap-1 text-ld-link font-medium hover:underline cursor-pointer"
      >
        {{ 'contactUsVisitFaqs' | transloco }}
        <mat-icon class="w-5! h-5! text-[20px]!" aria-hidden="true">arrow_forward</mat-icon>
      </a>
    </div>

    <div id="contact-us-specialized-section" class="mb-10">
      <h2 id="contact-us-specialized-heading" class="text-section-heading mb-6">
        {{ 'contactUsSpecializedHeading' | transloco }}
      </h2>

      <div class="grid grid-cols-1 md:grid-cols-2 gap-6">
        <article
          id="contact-section-property-taxes-escrow"
          class="bg-white rounded-xl border border-ld-neutral-200 p-6"
        >
          <h3 class="text-card-title text-ld-neutral mb-3">
            {{ 'contactUsPropertyTaxesEscrowHeading' | transloco }}
          </h3>
          <p class="text-body text-ld-neutral-600 mb-4 leading-relaxed">
            {{ 'contactUsPropertyTaxesEscrowDetails' | transloco }}
          </p>
          <div class="space-y-2">
            <div class="flex items-start gap-2">
              <mat-icon class="w-5! h-5! text-[20px]! text-ld-neutral-500 shrink-0 mt-0.5" aria-hidden="true">
                location_on
              </mat-icon>
              <span class="text-sm text-ld-neutral">{{ propertyTaxesEscrow.address }}</span>
            </div>
            <div class="flex items-center gap-2">
              <mat-icon class="w-5! h-5! text-[20px]! text-ld-neutral-500 shrink-0" aria-hidden="true">phone</mat-icon>
              <a
                [href]="'tel:' + propertyTaxesEscrow.phone"
                class="text-sm text-ld-link font-medium hover:underline cursor-pointer"
              >
                {{ propertyTaxesEscrow.phoneDisplay }}
              </a>
            </div>
            <div class="flex items-center gap-2">
              <mat-icon class="w-5! h-5! text-[20px]! text-ld-neutral-500 shrink-0" aria-hidden="true">fax</mat-icon>
              <span class="text-sm text-ld-neutral">{{ propertyTaxesEscrow.faxDisplay }}</span>
            </div>
            <div class="flex items-center gap-2">
              <mat-icon class="w-5! h-5! text-[20px]! text-ld-neutral-500 shrink-0" aria-hidden="true">email</mat-icon>
              <a
                [href]="'mailto:' + propertyTaxesEscrow.email"
                class="text-sm text-ld-link font-medium hover:underline cursor-pointer"
              >
                {{ propertyTaxesEscrow.email }}
              </a>
            </div>
          </div>
        </article>

        <article
          id="contact-section-property-taxes-non-escrow"
          class="bg-white rounded-xl border border-ld-neutral-200 p-6"
        >
          <h3 class="text-card-title text-ld-neutral mb-3">
            {{ 'contactUsPropertyTaxesNonEscrowHeading' | transloco }}
          </h3>
          <p class="text-body text-ld-neutral-600 mb-4 leading-relaxed">
            {{ 'contactUsPropertyTaxesNonEscrowDetails' | transloco }}
          </p>
          <div class="space-y-2">
            <div class="flex items-start gap-2">
              <mat-icon class="w-5! h-5! text-[20px]! text-ld-neutral-500 shrink-0 mt-0.5" aria-hidden="true">
                location_on
              </mat-icon>
              <span class="text-sm text-ld-neutral">{{ propertyTaxesNonEscrow.address }}</span>
            </div>
            <div class="flex items-center gap-2">
              <mat-icon class="w-5! h-5! text-[20px]! text-ld-neutral-500 shrink-0" aria-hidden="true">phone</mat-icon>
              <a
                [href]="'tel:' + propertyTaxesNonEscrow.phone"
                class="text-sm text-ld-link font-medium hover:underline cursor-pointer"
              >
                {{ propertyTaxesNonEscrow.phoneDisplay }}
              </a>
            </div>
            <div class="flex items-center gap-2">
              <mat-icon class="w-5! h-5! text-[20px]! text-ld-neutral-500 shrink-0" aria-hidden="true">fax</mat-icon>
              <span class="text-sm text-ld-neutral">{{ propertyTaxesNonEscrow.faxDisplay }}</span>
            </div>
            <div class="flex items-center gap-2">
              <mat-icon class="w-5! h-5! text-[20px]! text-ld-neutral-500 shrink-0" aria-hidden="true">email</mat-icon>
              <a
                [href]="'mailto:' + propertyTaxesNonEscrow.email"
                class="text-sm text-ld-link font-medium hover:underline cursor-pointer"
              >
                {{ propertyTaxesNonEscrow.email }}
              </a>
            </div>
          </div>
        </article>

        <article id="contact-section-homeowners-insurance" class="bg-white rounded-xl border border-ld-neutral-200 p-6">
          <h3 class="text-card-title text-ld-neutral mb-3">
            {{ 'contactUsHomeownersInsuranceHeading' | transloco }}
          </h3>
          <p class="text-body text-ld-neutral-600 mb-4 leading-relaxed">
            {{ 'contactUsHomeownersInsuranceDetails' | transloco }}
          </p>
          <div class="space-y-2">
            <div class="flex items-start gap-2">
              <mat-icon class="w-5! h-5! text-[20px]! text-ld-neutral-500 shrink-0 mt-0.5" aria-hidden="true">
                location_on
              </mat-icon>
              <div class="text-sm text-ld-neutral">
                <span>{{ homeownersInsurance.location1 }}</span>
                <br />
                <span>{{ homeownersInsurance.location2 }}</span>
              </div>
            </div>
            <div class="flex items-center gap-2">
              <mat-icon class="w-5! h-5! text-[20px]! text-ld-neutral-500 shrink-0" aria-hidden="true">phone</mat-icon>
              <a
                [href]="'tel:' + homeownersInsurance.phone"
                class="text-sm text-ld-link font-medium hover:underline cursor-pointer"
              >
                {{ homeownersInsurance.phoneDisplay }}
              </a>
            </div>
            <div class="flex items-center gap-2">
              <mat-icon class="w-5! h-5! text-[20px]! text-ld-neutral-500 shrink-0" aria-hidden="true">fax</mat-icon>
              <span class="text-sm text-ld-neutral">{{ homeownersInsurance.faxDisplay }}</span>
            </div>
            <div class="flex items-center gap-2">
              <mat-icon class="w-5! h-5! text-[20px]! text-ld-neutral-500 shrink-0" aria-hidden="true">
                language
              </mat-icon>
              <span class="text-sm">
                <a
                  [href]="homeownersInsurance.websiteUrl"
                  target="_blank"
                  rel="noopener"
                  class="text-ld-link font-medium hover:underline cursor-pointer"
                >
                  {{ homeownersInsurance.website }}
                </a>
                <span class="text-ld-neutral">- Enter Code {{ homeownersInsurance.websiteCode }}</span>
              </span>
            </div>
          </div>
        </article>

        <article id="contact-section-insurance-claims" class="bg-white rounded-xl border border-ld-neutral-200 p-6">
          <h3 class="text-card-title text-ld-neutral mb-3">
            {{ 'insuranceClaimsTitle' | transloco }}
          </h3>
          <p class="text-body text-ld-neutral-600 mb-4 leading-relaxed">
            {{ 'contactUsInsuranceClaimsDetailsPrefix' | transloco }}
            <a
              [href]="insuranceClaims.claimProcedurePacketUrl"
              target="_blank"
              rel="noopener"
              class="text-ld-link font-medium hover:underline cursor-pointer"
            >
              {{ 'contactUsClaimProcedurePacket' | transloco }}
            </a>
            {{ 'contactUsInsuranceClaimsDetailsSuffix' | transloco }}
          </p>
          <div class="space-y-2">
            <div class="flex items-start gap-2">
              <mat-icon class="w-5! h-5! text-[20px]! text-ld-neutral-500 shrink-0 mt-0.5" aria-hidden="true">
                location_on
              </mat-icon>
              <div class="text-sm text-ld-neutral">
                <span>{{ insuranceClaims.location1 }}</span>
                <br />
                <span>{{ insuranceClaims.location2 }}</span>
              </div>
            </div>
            <div class="flex items-center gap-2">
              <mat-icon class="w-5! h-5! text-[20px]! text-ld-neutral-500 shrink-0" aria-hidden="true">phone</mat-icon>
              <a
                [href]="'tel:' + insuranceClaims.phone"
                class="text-sm text-ld-link font-medium hover:underline cursor-pointer"
              >
                {{ insuranceClaims.phoneDisplay }}
              </a>
            </div>
            <div class="flex items-center gap-2">
              <mat-icon class="w-5! h-5! text-[20px]! text-ld-neutral-500 shrink-0" aria-hidden="true">fax</mat-icon>
              <span class="text-sm text-ld-neutral">{{ insuranceClaims.faxDisplay }}</span>
            </div>
          </div>
        </article>

        <article
          id="contact-section-written-correspondence"
          class="bg-white rounded-xl border border-ld-neutral-200 p-6"
        >
          <h3 class="text-card-title text-ld-neutral mb-3">
            {{ 'contactUsWrittenCorrespondenceHeading' | transloco }}
          </h3>
          <div class="space-y-2">
            <div class="flex items-start gap-2">
              <mat-icon class="w-5! h-5! text-[20px]! text-ld-neutral-500 shrink-0 mt-0.5" aria-hidden="true">
                location_on
              </mat-icon>
              <span class="text-sm text-ld-neutral">{{ writtenCorrespondenceAddress }}</span>
            </div>
          </div>
        </article>

        <article id="contact-section-payoff-statements" class="bg-white rounded-xl border border-ld-neutral-200 p-6">
          <h3 class="text-card-title text-ld-neutral mb-3">
            {{ 'contactUsPayoffStatementsHeading' | transloco }}
          </h3>
          <div class="space-y-2">
            <div class="flex items-center gap-2">
              <mat-icon class="w-5! h-5! text-[20px]! text-ld-neutral-500 shrink-0" aria-hidden="true">email</mat-icon>
              <a
                [href]="'mailto:' + payoffStatements.email"
                class="text-sm text-ld-link font-medium hover:underline cursor-pointer"
              >
                {{ payoffStatements.email }}
              </a>
            </div>
            <div class="flex items-center gap-2">
              <mat-icon class="w-5! h-5! text-[20px]! text-ld-neutral-500 shrink-0" aria-hidden="true">fax</mat-icon>
              <span class="text-sm text-ld-neutral">{{ payoffStatements.faxDisplay }}</span>
            </div>
          </div>
        </article>
      </div>
    </div>

    <div id="contact-us-help-section" class="bg-ld-primary-50 rounded-xl p-6 mb-10">
      <h2 id="contact-us-help-heading" class="text-section-heading mb-4">
        {{ 'contactUsHereToHelpHeading' | transloco }}
      </h2>

      <div class="space-y-4 text-sm text-ld-neutral-700 leading-relaxed">
        <p id="contact-us-help-text-1">
          {{ 'contactUsHereToHelpText1' | transloco }}
          <a
            [href]="customerServiceTel()"
            class="text-ld-link font-medium hover:underline cursor-pointer whitespace-nowrap"
          >
            {{ customerServicePhone() }}
          </a>
          .
        </p>

        <p id="contact-us-help-text-2">
          {{ 'contactUsHereToHelpText2' | transloco }}
          <a
            [href]="homeownerSupportUrl"
            target="_blank"
            rel="noopener"
            class="text-ld-link font-medium hover:underline cursor-pointer"
          >
            {{ 'contactUsHomeownerSupportResource' | transloco }}
          </a>
          {{ 'contactUsHereToHelpText2Suffix' | transloco }}
        </p>

        <p id="contact-us-help-text-3">
          {{ 'contactUsHereToHelpText3' | transloco }}
          <a
            [href]="'tel:' + hudCounseling.phone"
            class="text-ld-link font-medium hover:underline cursor-pointer whitespace-nowrap"
          >
            {{ hudCounseling.phoneDisplay }}
          </a>
        </p>

        <p id="contact-us-help-text-4">
          {{ 'contactUsHereToHelpText4' | transloco }}
          <a
            [href]="'tel:' + waHotline.phone"
            class="text-ld-link font-medium hover:underline cursor-pointer whitespace-nowrap"
          >
            {{ waHotline.phoneDisplay }}
          </a>
          .
          {{ 'contactUsHereToHelpText4Suffix' | transloco }}
        </p>
      </div>
    </div>

    <div id="contact-us-disclosures-section" class="mb-10">
      <h2 id="contact-us-disclosures-heading" class="text-lg font-bold text-ld-neutral mb-2">
        {{ 'contactUsImportantDisclosuresHeading' | transloco }}
      </h2>
      <p class="text-sm text-ld-neutral-700 mb-6">
        {{ 'contactUsImportantDisclosuresSubtext' | transloco }}
      </p>

      <div class="mb-6">
        <h3 class="text-base font-bold text-ld-neutral mb-2">
          {{ 'contactUsDisclosureTexasHeading' | transloco }}
        </h3>
        <p class="text-sm text-ld-neutral-700 font-bold leading-relaxed">
          {{ 'contactUsDisclosureTexasText' | transloco }}
          <a [href]="texasHotlineTel" class="text-ld-link font-bold hover:underline cursor-pointer whitespace-nowrap">
            {{ texasHotlinePhone }}
          </a>
          .
        </p>
      </div>

      <div>
        <h3 class="text-base font-bold text-ld-neutral mb-2">
          {{ 'contactUsDisclosureNewYorkHeading' | transloco }}
        </h3>
        <p class="text-sm text-ld-neutral-700 leading-relaxed">
          {{ 'contactUsDisclosureNewYorkText1' | transloco }}
          <a [href]="nyDfsTel" class="text-ld-link font-medium hover:underline cursor-pointer whitespace-nowrap">
            {{ nyDfsPhone }}
          </a>
          {{ 'contactUsDisclosureNewYorkText2' | transloco }}
          <a
            [href]="nyDfsUrl"
            target="_blank"
            rel="noopener"
            class="text-ld-link font-medium hover:underline cursor-pointer"
          >
            {{ nyDfsUrl }}
          </a>
          .
        </p>
      </div>
    </div>

    <aside id="contact-us-sidebar" class="mt-8 lg:mt-[52px] lg:col-start-2! lg:[grid-row:3/span_99]">
      <ld-contact-card id="contact-us-contact-card" />
    </aside>
  </div>
</section>
